/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d

import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import LoyaltyBannerLabels from '../container/LoyaltyBanner.labels';
import {
  GENERIC_GLOBAL,
  globalGenericLabels,
  PDP_PLCC_LABELS,
  pdpPLCCBannerLabelsData,
} from '../molecules/GuestMprPlccSection/views/GuestMprPlccSection.label';

const LOYALTY_BANNER_LABEL = 'global.loyalityBanner';
const placeholderValue = '#plccOfferPercentage#';

/* eslint-disable max-params */

// TODO: This file contains Dynamic labels
const getPageCategory = (pageCategory) => {
  let ischeckoutPage = false;
  let isReviewPage = false;
  let isConfirmationPage = false;
  let isAddedToBagPage = false;
  let isProductDetailView = false;
  switch (pageCategory) {
    case 'isProductDetailView':
      isProductDetailView = true;
      break;
    case 'review':
      isReviewPage = true;
      break;
    case 'confirmation':
      isConfirmationPage = true;
      break;
    case 'isAddedToBagPage':
      isAddedToBagPage = true;
      break;

    default:
      ischeckoutPage = true;
  }
  return {
    ischeckoutPage,
    isReviewPage,
    isConfirmationPage,
    isAddedToBagPage,
    isProductDetailView,
  };
};
const reviewPageLabelsFn = (earnedReward, estimatedRewardsVal, isGuest, isPlcc) => {
  let rewardPointsValue = '';
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let descriptionLabel = '';
  let remainingPlccVal = '';
  const loyaltyLabels = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );

  if (!earnedReward) {
    rewardPointsValue = estimatedRewardsVal;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_review_guest_points_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_review_guest_points_label2;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_review_mpr_points_label1;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_review_plcc_points_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_review_plcc_points_label2;
      remainingPlccVal = loyaltyLabels.lbl_banner_review_plcc_points_label3;
    }
  } else {
    rewardPointsValue = earnedReward;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_review_guest_rewards_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_review_guest_rewards_label2;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_review_mpr_rewards_label1;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_review_plcc_rewards_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_review_plcc_rewards_label2;
    }
  }
  return {
    rewardPointsValue,
    headingLabelVal,
    subHeadingLabel,
    descriptionLabel,
    remainingPlccVal,
  };
};

const confirmationPageLabelsFn = (earnedReward, estimatedRewardsVal, isGuest, isPlcc) => {
  let rewardPointsValue = '';
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let remainingPlccVal = '';
  const loyaltyLabels = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );

  if (!earnedReward) {
    rewardPointsValue = estimatedRewardsVal;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_guest_points_label1;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_mpr_points_label1;
      remainingPlccVal = loyaltyLabels.lbl_banner_confirmation_mpr_points_label2;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_plcc_points_label1;
      remainingPlccVal = loyaltyLabels.lbl_banner_confirmation_plcc_points_label2;
    }
  } else {
    rewardPointsValue = earnedReward;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_guest_rewards_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_confirmation_guest_rewards_label2;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_mpr_rewards_label1;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_confirmation_plcc_rewards_label1;
    }
  }
  return {
    rewardPointsValue,
    headingLabelVal,
    subHeadingLabel,
    remainingPlccVal,
  };
};

const addedToBagPageLabelsFn = (
  earnedReward,
  estimatedRewardsVal,
  isGuest,
  isPlcc,
  isAddedToBagRedesign
) => {
  let rewardPointsValue = '';
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let descriptionLabel = '';
  const loyaltyLabels = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );

  if (!earnedReward) {
    rewardPointsValue = estimatedRewardsVal;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_guest_points_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_added2bag_guest_points_label2;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_mpr_points_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_added2bag_mpr_points_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_added2bag_mpr_points_label3;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_plcc_points_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_added2bag_plcc_points_label2;
    }
  } else {
    rewardPointsValue = earnedReward;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_guest_rewards_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_added2bag_guest_rewards_label2;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_mpr_rewards_label1;
      subHeadingLabel = loyaltyLabels.lbl_banner_added2bag_mpr_rewards_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_added2bag_mpr_rewards_label3;
      if (isAddedToBagRedesign) {
        headingLabelVal = loyaltyLabels.lbl_banner_bag_plcc_rewards_label1;
      }
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_added2bag_plcc_rewards_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_added2bag_plcc_rewards_label2;
    }
  }
  return {
    rewardPointsValue,
    headingLabelVal,
    subHeadingLabel,
    descriptionLabel,
  };
};

const getLabelTextMPRHeadingText = (
  isLoyaltyTieringEnabled,
  pdpPLCCBannerLabels,
  genericLabelsObj
) => {
  return `${pdpPLCCBannerLabels.lbl_banner_pdp_mpr_rewards_label} ${
    isLoyaltyTieringEnabled
      ? pdpPLCCBannerLabels.lbl_PLCC_reward_brand_theme
      : pdpPLCCBannerLabels.lbl_PLCC_reward_multiclr
  } ${genericLabelsObj.lbl_creditCard}`;
};

const productDetailPageLabelsFn = (
  isGuest,
  isPlcc,
  isPromoRedesignOnPDP,
  isLoyaltyTieringEnabled = false
) => {
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let descriptionLabel = '';
  const genericLabelsObj = getLabelFromCopyOrFromTranslation(GENERIC_GLOBAL, globalGenericLabels);
  const loyalityLabel = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );
  const pdpPLCCBannerLabels = getLabelFromCopyOrFromTranslation(
    PDP_PLCC_LABELS,
    pdpPLCCBannerLabelsData
  );
  const labelTextMPRHeadingText = getLabelTextMPRHeadingText(
    isLoyaltyTieringEnabled,
    pdpPLCCBannerLabels,
    genericLabelsObj
  );

  const labelTextPLCCHeadingText = `${pdpPLCCBannerLabels.lbl_banner_pdp_plcc_rewards_label} ${pdpPLCCBannerLabels.lbl_PLCC_reward_multiclr} ${genericLabelsObj.lbl_creditCard}`;

  if (isGuest) {
    headingLabelVal = isPromoRedesignOnPDP
      ? pdpPLCCBannerLabels.lbl_banner_pdp_guest_rewards_label1
      : loyalityLabel.lbl_banner_pdp_guest_rewards_label1;
    subHeadingLabel = isPromoRedesignOnPDP
      ? pdpPLCCBannerLabels.lbl_banner_pdp_guest_rewards_label2
      : getDynamicLabelValues('dynamic.global_d.lbl_banner_pdp_guest_rewards_label2');
  } else if (!isPlcc) {
    headingLabelVal = isPromoRedesignOnPDP
      ? labelTextMPRHeadingText
      : loyalityLabel.lbl_banner_pdp_mpr_rewards_label1;
    descriptionLabel = isPromoRedesignOnPDP ? '' : loyalityLabel.lbl_banner_pdp_mpr_rewards_label3;
  } else {
    headingLabelVal = isPromoRedesignOnPDP
      ? labelTextPLCCHeadingText
      : loyalityLabel.lbl_banner_pdp_plcc_rewards_label1;
    descriptionLabel = isPromoRedesignOnPDP ? '' : loyalityLabel.lbl_banner_pdp_plcc_rewards_label2;
  }
  return {
    headingLabelVal,
    subHeadingLabel,
    descriptionLabel,
  };
};

const fancyBannerLabelsFn = (earnedReward, estimatedRewardsVal, isGuest, isPlcc) => {
  let rewardPointsValue = '';
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let descriptionLabel = '';
  let remainingPlccVal = '';
  const loyaltyLabels = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );

  descriptionLabel = loyaltyLabels.lbl_banner_fancy_checkout_rewards_label;
  subHeadingLabel = loyaltyLabels.lbl_banner_fancy_checkout_save_msg;

  if (!earnedReward) {
    rewardPointsValue = estimatedRewardsVal;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_guest_points_label1;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_mpr_points_label1;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_plcc_points_label1;
      remainingPlccVal = loyaltyLabels.lbl_banner_bag_plcc_points_label3;
      subHeadingLabel = '';
    }
  } else {
    rewardPointsValue = earnedReward;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_guest_rewards_label1;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_mpr_rewards_label1;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_plcc_rewards_label1;
      subHeadingLabel = '';
    }
  }

  return {
    rewardPointsValue,
    headingLabelVal,
    subHeadingLabel,
    descriptionLabel,
    remainingPlccVal,
  };
};

const bagCheckoutPageLabelsFn = (
  earnedReward,
  estimatedRewardsVal,
  isGuest,
  isPlcc,
  plccOfferPercentage
) => {
  let rewardPointsValue = '';
  let headingLabelVal = '';
  let subHeadingLabel = '';
  let descriptionLabel = '';
  let remainingPlccVal = '';
  const loyaltyLabels = getLabelFromCopyOrFromTranslation(
    LOYALTY_BANNER_LABEL,
    LoyaltyBannerLabels
  );
  const loyaltyDynamicLabels = getDynamicLabelValues('dynamic.global_d');

  if (!earnedReward) {
    rewardPointsValue = estimatedRewardsVal;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_guest_points_label1;
      subHeadingLabel = loyaltyDynamicLabels.lbl_banner_bag_guest_points_label2?.includes(
        placeholderValue
      )
        ? loyaltyDynamicLabels.lbl_banner_bag_guest_points_label2?.replace(
            placeholderValue,
            plccOfferPercentage
          )
        : loyaltyDynamicLabels.lbl_banner_bag_guest_points_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_guest_points_label3;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_mpr_points_label1;
      subHeadingLabel = loyaltyDynamicLabels.lbl_banner_bag_mpr_points_label2?.includes(
        placeholderValue
      )
        ? loyaltyDynamicLabels.lbl_banner_bag_mpr_points_label2?.replace(
            placeholderValue,
            plccOfferPercentage
          )
        : loyaltyDynamicLabels.lbl_banner_bag_mpr_points_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_mpr_points_label3;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_plcc_points_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_plcc_points_label2;
      remainingPlccVal = loyaltyLabels.lbl_banner_bag_plcc_points_label3;
    }
  } else {
    rewardPointsValue = earnedReward;
    if (isGuest) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_guest_rewards_label1;
      subHeadingLabel = loyaltyDynamicLabels.lbl_banner_bag_guest_rewards_label2?.includes(
        placeholderValue
      )
        ? loyaltyDynamicLabels.lbl_banner_bag_guest_rewards_label2?.replace(
            placeholderValue,
            plccOfferPercentage
          )
        : loyaltyDynamicLabels.lbl_banner_bag_guest_rewards_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_guest_rewards_label3;
    } else if (!isPlcc) {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_mpr_rewards_label1;
      subHeadingLabel = loyaltyDynamicLabels.lbl_banner_bag_mpr_rewards_label2?.includes(
        placeholderValue
      )
        ? loyaltyDynamicLabels.lbl_banner_bag_mpr_rewards_label2?.replace(
            placeholderValue,
            plccOfferPercentage
          )
        : loyaltyDynamicLabels.lbl_banner_bag_mpr_rewards_label2;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_mpr_rewards_label3;
    } else {
      headingLabelVal = loyaltyLabels.lbl_banner_bag_plcc_rewards_label1;
      descriptionLabel = loyaltyLabels.lbl_banner_bag_plcc_rewards_label2;
    }
  }
  return {
    rewardPointsValue,
    headingLabelVal,
    subHeadingLabel,
    descriptionLabel,
    remainingPlccVal,
  };
};

const renderLoyaltyLabels = (
  plccOfferPercentage,
  estimatedRewardsVal,
  earnedReward,
  isGuest,
  isPlcc,
  isReviewPage,
  isConfirmationPage,
  isAddedToBagPage,
  isProductDetailView,
  isFancyBanner,
  isAddedToBagRedesign,
  isPromoRedesignOnPDP,
  isLoyaltyTieringEnabled
) => {
  let rewardPointsValueFn = '';
  let headingLabelValFn = '';
  let subHeadingLabelFn = '';
  let descriptionLabelFn = '';
  let remainingPlccValFn = '';
  if (isReviewPage) {
    const reviewPageLabels = reviewPageLabelsFn(earnedReward, estimatedRewardsVal, isGuest, isPlcc);
    rewardPointsValueFn = reviewPageLabels.rewardPointsValue;
    headingLabelValFn = reviewPageLabels.headingLabelVal;
    subHeadingLabelFn = reviewPageLabels.subHeadingLabel;
    descriptionLabelFn = reviewPageLabels.descriptionLabel;
    remainingPlccValFn = reviewPageLabels.remainingPlccVal;
  } else if (isConfirmationPage) {
    const confirmationPageLabels = confirmationPageLabelsFn(
      earnedReward,
      estimatedRewardsVal,
      isGuest,
      isPlcc
    );
    rewardPointsValueFn = confirmationPageLabels.rewardPointsValue;
    headingLabelValFn = confirmationPageLabels.headingLabelVal;
    subHeadingLabelFn = confirmationPageLabels.subHeadingLabel;
    descriptionLabelFn = confirmationPageLabels.descriptionLabel;
    remainingPlccValFn = confirmationPageLabels.remainingPlccVal;
  } else if (isAddedToBagPage) {
    const addedToBagPageLabels = addedToBagPageLabelsFn(
      earnedReward,
      estimatedRewardsVal,
      isGuest,
      isPlcc,
      isAddedToBagRedesign
    );
    rewardPointsValueFn = addedToBagPageLabels.rewardPointsValue;
    headingLabelValFn = addedToBagPageLabels.headingLabelVal;
    subHeadingLabelFn = addedToBagPageLabels.subHeadingLabel;
    descriptionLabelFn = addedToBagPageLabels.descriptionLabel;
    remainingPlccValFn = addedToBagPageLabels.remainingPlccVal;
  } else if (isProductDetailView) {
    const productDetailPageLabels = productDetailPageLabelsFn(
      isGuest,
      isPlcc,
      isPromoRedesignOnPDP,
      isLoyaltyTieringEnabled
    );
    headingLabelValFn = productDetailPageLabels.headingLabelVal;
    subHeadingLabelFn = productDetailPageLabels.subHeadingLabel;
    descriptionLabelFn = productDetailPageLabels.descriptionLabel;
  } else {
    let bagcheckoutPageLabels;
    if (isFancyBanner) {
      bagcheckoutPageLabels = fancyBannerLabelsFn(
        earnedReward,
        estimatedRewardsVal,
        isGuest,
        isPlcc
      );
    } else {
      bagcheckoutPageLabels = bagCheckoutPageLabelsFn(
        earnedReward,
        estimatedRewardsVal,
        isGuest,
        isPlcc,
        plccOfferPercentage
      );
    }
    rewardPointsValueFn = bagcheckoutPageLabels.rewardPointsValue;
    headingLabelValFn = bagcheckoutPageLabels.headingLabelVal;
    subHeadingLabelFn = bagcheckoutPageLabels.subHeadingLabel;
    descriptionLabelFn = bagcheckoutPageLabels.descriptionLabel;
    remainingPlccValFn = bagcheckoutPageLabels.remainingPlccVal;
  }

  return {
    rewardPointsValueFn,
    headingLabelValFn,
    subHeadingLabelFn,
    descriptionLabelFn,
    remainingPlccValFn,
  };
};

export { renderLoyaltyLabels, getPageCategory };
